import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getReportList, reportIDsSelector } from '../../features/datacenter/reportSlice';

import { blue } from '@mui/material/colors';
import GetAppIcon from '@mui/icons-material/GetApp';
import { Paper, Typography, Grid, ButtonGroup, Button, Avatar } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';
import { useTheme } from '@mui/material/styles';

import GetReportForm from './GetReportForm';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        '& > *': {
            margin: useTheme().spacing(1),
        },
    },
    small: {
        width: useTheme().spacing(2),
        height: useTheme().spacing(2),
        color: '#fff',
        backgroundColor: blue[500],
    },
}));

const ReportViewTop = () => {

    const dispatch = useDispatch();
    const classes = useStyles();
    const reportIDs = useSelector(reportIDsSelector);
    const [reportFormOpen, seReportFormOpen] = useState(false);

    const handleReportFormOpen = () => {
        seReportFormOpen(true);
    };
    const handleReportFormClose = () => {
        seReportFormOpen(false);
    }

    useEffect(() => {
        //console.log("Get track list");
        dispatch(getReportList());
    }, [dispatch]);

    return (
        <Paper>
            <div style={{
                marginLeft: '15px',
            }}>
                <Grid container spacing={1}>
                    <Grid item sm={12}>
                        <Typography variant="h6">
                            <b>Reports</b>
                        </Typography>
                    </Grid>

                    <Grid item sm={12}>
                        <ButtonGroup color="primary" variant="outlined" size="small">

                            <Button
                                onClick={handleReportFormOpen}
                                startIcon={<GetAppIcon color="primary" />}
                            >
                                Get Reports
                            </Button>
                            <Button
                                onClick={() => { }}
                                endIcon={
                                    <Avatar className={classes.small}>
                                        <Typography variant="caption">
                                            {reportIDs.length}
                                        </Typography>
                                    </Avatar>
                                }
                            >
                                Saved Reports
                            </Button>
                        </ButtonGroup>
                    </Grid>
                    <Grid item>
                        <div style={{ height: '10px' }}></div>
                    </Grid>
                </Grid>
            </div>
            <GetReportForm
                reportFormOpen={reportFormOpen}
                handleReportFormClose={handleReportFormClose}
            />
        </Paper>
    );
}

export default ReportViewTop;